
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.203 11.453v3.922H.86V5.187C.86 2.25 2.04.782 4.4.782c.89 0 1.596.222 2.117.664.526.438.789 1.045.789 1.82 0 1.34-.756 2.256-2.266 2.75v.063c1.703.39 2.555 1.388 2.555 2.992 0 .99-.31 1.748-.93 2.274-.62.52-1.385.781-2.297.781-.823 0-1.544-.224-2.164-.672zm1.203-5.008V5.82c.735-.026 1.334-.263 1.797-.71.464-.454.695-1.048.695-1.782 0-.599-.15-1.062-.453-1.39-.297-.334-.7-.5-1.21-.5-.725 0-1.245.32-1.563.96-.313.636-.469 1.602-.469 2.899v4.64c0 .48.185.857.555 1.133.375.276.815.414 1.32.414 1.365 0 2.047-.77 2.047-2.312 0-.828-.237-1.485-.71-1.969-.47-.484-1.139-.737-2.009-.758z","fill":"currentColor"}})])
          )
        }
      }
    